import { configureStore } from '@reduxjs/toolkit'
import {
  testSlice,
  sessionSlice,
  formsSlice,
  analyzersSlice,
  scriptsSlice,
  configsSlice,
  jobsSlice,
  resultsSlice,
  datasetsSlice,
  loadState,
  strategySlice,
  serverSlice,
  accountsSlice,
  notificationsSlice,
  manualUploadsSlice,
  dataSlice,
  UserpreferenceSlice,
  initialAnalyzersState,
  initialScriptsState,
  initialConfigsState,
  initialJobsState,
  initialResultsState,
  initialDatasetsState,
  initialServerState,
  initialAccountsState,
  initialNotificationsState,
  initialSessionState,
  initialManualUploadsState,
  initialDataState,
  initialUserPreferenceState,
  SessionState,
  FormState,
  AnalyzerState,
  ScriptState,
  ConfigState,
  JobState,
  ResultState,
  DataSetState,
  StrategyState,
  AccountsState,
  NotificationsState,
  ManualUploadState,
  DataState,
  TestState,
  ServerState,
  UserPreferenceState
} from './slices'

export interface DefaultState {
  test: TestState
  session: SessionState
  forms: FormState
  analyzers: AnalyzerState
  scripts: ScriptState
  configs: ConfigState
  jobs: JobState
  results: ResultState
  datasets: DataSetState
  strategies: StrategyState
  server: ServerState
  accounts: AccountsState
  notifications: NotificationsState
  manualUploads: ManualUploadState
  data: DataState,
  userPreference: UserPreferenceState
}


const store = configureStore<DefaultState>({
  reducer: {
    test: testSlice.reducer,
    session: sessionSlice.reducer,
    forms: formsSlice.reducer,
    analyzers: analyzersSlice.reducer,
    scripts: scriptsSlice.reducer,
    configs: configsSlice.reducer,
    jobs: jobsSlice.reducer,
    results: resultsSlice.reducer,
    datasets: datasetsSlice.reducer,
    strategies: strategySlice.reducer,
    server: serverSlice.reducer,
    accounts: accountsSlice.reducer,
    notifications: notificationsSlice.reducer,
    manualUploads: manualUploadsSlice.reducer,
    data: dataSlice.reducer,
    userPreference: UserpreferenceSlice.reducer
  },
  preloadedState: {
    test: {},
    session: initialSessionState,
    forms: loadState(),
    analyzers: initialAnalyzersState,
    scripts: initialScriptsState,
    configs: initialConfigsState,
    jobs: initialJobsState,
    results: initialResultsState,
    datasets: initialDatasetsState,
    server: initialServerState,
    accounts: initialAccountsState,
    notifications: initialNotificationsState,
    data: initialDataState,
    userPreference: initialUserPreferenceState
  },
})

  //middleware: (getDefaultMiddleware) =>
  //  getDefaultMiddleware().concat(dataApi.middleware)

export default store